import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

function Navbar() {
    const navigate = useNavigate();

    const [sidebar,setSidebar] = useState(false);

  return (
    <div className='relative'>
      <div className='w-full flex p-1 bg-white sm:p-4 h-[100px] items-center text-lg justify-between font-medium font-sans' style={{zIndex:100,position:'-webkit-sticky',position:'sticky',top:0}}>
        <div className='text-2xl' style={{cursor:'pointer'}} onClick={()=>{
            navigate('/') 
            }}>
            PortFolio
        </div>
        {<div className='flex font-light'>
            <div className='m-1 sm:m-2 ' style={{cursor:'pointer'}} onClick={()=>{
            navigate('/project') 
            }}>Projects</div>
            <div className='m-1 sm:m-2'onClick={()=>{
            navigate('/about') 
            }}
            style={{cursor:'pointer'}}>About</div>
            <div className='m-1 sm:m-2'onClick={()=>{
            navigate('/contact') 
            }}
            style={{cursor:'pointer'}}>Contact</div>
        </div>}
      </div>
    </div>
  )
}

export default Navbar
